import { Link } from "react-router-dom";
import { hotRanking, events } from "@/mocks/gossip";

const tickerItems = hotRanking.map((r) => {
  const ev = events.find((e) => e.id === r.id);
  return { id: r.id, title: r.title, heat: r.heat, category: ev?.category ?? "" };
});

export default function TrendingTicker() {
  const loop = [...tickerItems, ...tickerItems];
  return (
    <section
      aria-label="今日热榜滚动"
      className="w-full border-y border-background-200 bg-foreground-950 text-background-100"
    >
      <div className="flex items-center">
        <div className="flex shrink-0 items-center gap-2 bg-primary-500 px-4 md:px-6 py-3.5 text-background-50">
          <i className="ri-flashlight-fill text-base"></i>
          <span className="font-label text-sm whitespace-nowrap">今日热榜</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee">
            {loop.map((item, idx) => (
              <Link
                key={`${item.id}-${idx}`}
                to={`/event/${item.id}`}
                className="flex shrink-0 items-center gap-2 px-5 py-3.5 font-label text-sm text-background-200 hover:text-accent-300 transition-colors cursor-pointer"
              >
                <span className="text-accent-400 font-heading font-bold">{String((idx % tickerItems.length) + 1).padStart(2, "0")}</span>
                <span className="whitespace-nowrap">{item.title}</span>
                <span className="flex items-center gap-1 text-[11px] text-background-400 whitespace-nowrap">
                  <i className="ri-fire-line"></i>
                  {item.heat}
                </span>
                <span className="mx-2 h-3 w-px bg-background-700"></span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}